import { ThemeProvider, ToasterProvider } from '@/contexts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeflex/primeflex.css';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";

import "timepicker-ui/main.css";

import App from '@/App.jsx';
import { store } from '@/app/store';
import '@/utils/languagedetector/i18n.js';

import "./flags.scss";
import "./index.scss";

import i18n from '@/utils/languagedetector/i18n.js';
import { setTranslator } from '@gyandiksha/shared-ui/utils/translator';
setTranslator(i18n.t);

// Skip mounting when the browser check (index.html) found an unsupported browser
if (!window.__GD_UNSUPPORTED_BROWSER__) createRoot(document.getElementById('root')).render(
  // <StrictMode>
  <ThemeProvider>
    <ToasterProvider>
      <PrimeReactProvider>
        {/* <ToastContainer autoClose={3000} /> */}
        <Provider store={store}>
          <App />
        </Provider>
      </PrimeReactProvider>
    </ToasterProvider>
  </ThemeProvider>
  // </StrictMode>,
)